import styled from 'styled-components';

const Title = styled.span`
  margin: 0px;
  font-size: ${p => (p.size === 'small' ? '16px' : '16px')};
  font-family: ${p => (p.theme.fontFamily ? p.theme.fontFamily : 'inherit')};
  font-weight: ${p => (p.style.fontWeight ? p.style.fontWeight : 500)};
  color: ${p => (p.style.color ? p.style.color : '#000')};
  display: ${p => (p.style.display ? p.style.display : 'block')};
  line-height: 1.5;
  cursor: ${p => (p.style.cursor ? p.style.cursor : 'inherit')};

  &:hover {
    color: ${p => (p.hover ? p.theme.colorPrimary : p.style.color)};
    transition: 0.5s;
  }
`;

Title.defaultProps = {
  style: {},
  size: null,
  hover: false,
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/text/Title/index.js